import { borderRadius, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

import { ChartPeerGroup } from '~/widgets/chart-peer-group/ChartPeerGroup';

export const SectionRow = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

export const TitleBase = styled.div`
  ${typographyV2.titleBase};
`;

export const ChartWrapper = styled.div`
  ${ChartPeerGroup.Styled.ChartContent} {
    height: 272px;
    padding: 0;
  }
  ${ChartPeerGroup.Styled.CheckboxContainer} {
    margin: 0;
    margin-bottom: 12px;
  }
`;

export const HeaderWrapper = styled.div`
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const FullscreenButtonContainer = styled.div`
  display: flex;
  ${borderRadius.r2}
  padding: 4px;
  background-color: var(--surface-default);
  height: 40px;
`;
